﻿import React, { FunctionComponent, ReactElement } from "react";
import { Tooltip } from "../Components";

export interface IIconProps
    extends Partial<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLSpanElement>,
            HTMLSpanElement
        >
    > {
    /**
     * An optional class to add style to the icon
     */
    className?: string;

    /**
     * An optional parameter to decide whether the icon is greyeyd out
     */
    disabled?: boolean;

    /**
     * An optional height for the icon. The detault value for this is 50px.
     */
    height?: number;

    /**
     * An optional onClick event for the icon
     */
    onClick?: { (event: React.SyntheticEvent): void };

    /**
     * An optional tooltip to provide feedback to the user
     */
    tooltip?: string;

    /**
     * The URL path for the icon
     */
    url: string;

    /**
     * An optional width for the icon. The default value for this is 50px.
     */
    width?: number;
}

export const Icon: FunctionComponent<IIconProps> = (props): ReactElement => {
    const canFireClickEvents = props.onClick !== undefined && !props.disabled,
        imageUrl: string =
            props.url !== null && props.url !== undefined && props.url !== ``
                ? `url(${props.url})`
                : `url(${ROOT_IMAGES_URL}Images/UI/Metribird.svg)`;

    let inlineStyle: React.CSSProperties = {
        backgroundImage: imageUrl,
    };

    if (props.width) {
        inlineStyle.width = props.width;
    }

    if (props.height) {
        inlineStyle.height = props.height;
    }

    if (canFireClickEvents) {
        inlineStyle.cursor = `pointer`;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { children, className, height, onClick, style, url, width, ...rest } =
        props;

    inlineStyle = {
        ...inlineStyle,
        ...style,
    };

    return (
        <Tooltip title={`${props.tooltip ? props.tooltip : ``}`}>
            <span
                className={`smarttools-icon ${className ? className : ``} ${
                    props.disabled ? `disabled` : ``
                }`}
                onClick={canFireClickEvents ? onClick : null}
                style={inlineStyle}
                {...rest}
            />
        </Tooltip>
    );
};
